"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/activity-query.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Factivity-query.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityFilter = exports.AccountQuery = void 0;
const protobufPackage = 'com.step.txactivity.proto';
function createBaseAccountQuery() {
    return { primaryAccountId: undefined, accountId: undefined };
}
exports.AccountQuery = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.primaryAccountId)) {
            message.primaryAccountId = globalThis.String(object.primaryAccountId);
        }
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== undefined) {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.accountId !== undefined) {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.AccountQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountQuery();
        message.primaryAccountId = object.primaryAccountId ?? undefined;
        message.accountId = object.accountId ?? undefined;
        return message;
    },
};
function createBaseActivityFilter() {
    return {
        merchantId: '',
        additionalMerchantIds: [],
        includeAllSpending: false,
        isBnplEligible: false,
        isBlocked: false,
        isInternational: false,
        excludeDeclines: false,
        excludeActivityIds: [],
        timeOnOrBeforeMs: '0',
        timeAfterMs: '0',
        isSettled: false,
    };
}
exports.ActivityFilter = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.merchantId)) {
            message.merchantId = globalThis.String(object.merchantId);
        }
        if (globalThis.Array.isArray(object?.additionalMerchantIds)) {
            message.additionalMerchantIds = object.additionalMerchantIds.map((e) => globalThis.String(e));
        }
        if (isSet(object.includeAllSpending)) {
            message.includeAllSpending = globalThis.Boolean(object.includeAllSpending);
        }
        if (isSet(object.isBnplEligible)) {
            message.isBnplEligible = globalThis.Boolean(object.isBnplEligible);
        }
        if (isSet(object.isBlocked)) {
            message.isBlocked = globalThis.Boolean(object.isBlocked);
        }
        if (isSet(object.isInternational)) {
            message.isInternational = globalThis.Boolean(object.isInternational);
        }
        if (isSet(object.excludeDeclines)) {
            message.excludeDeclines = globalThis.Boolean(object.excludeDeclines);
        }
        if (globalThis.Array.isArray(object?.excludeActivityIds)) {
            message.excludeActivityIds = object.excludeActivityIds.map((e) => globalThis.String(e));
        }
        if (isSet(object.timeOnOrBeforeMs)) {
            message.timeOnOrBeforeMs = globalThis.String(object.timeOnOrBeforeMs);
        }
        if (isSet(object.timeAfterMs)) {
            message.timeAfterMs = globalThis.String(object.timeAfterMs);
        }
        if (isSet(object.isSettled)) {
            message.isSettled = globalThis.Boolean(object.isSettled);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantId !== undefined && message.merchantId !== '') {
            obj.merchantId = message.merchantId;
        }
        if (message.additionalMerchantIds?.length) {
            obj.additionalMerchantIds = message.additionalMerchantIds;
        }
        if (message.includeAllSpending !== undefined && message.includeAllSpending !== false) {
            obj.includeAllSpending = message.includeAllSpending;
        }
        if (message.isBnplEligible !== undefined && message.isBnplEligible !== false) {
            obj.isBnplEligible = message.isBnplEligible;
        }
        if (message.isBlocked !== undefined && message.isBlocked !== false) {
            obj.isBlocked = message.isBlocked;
        }
        if (message.isInternational !== undefined && message.isInternational !== false) {
            obj.isInternational = message.isInternational;
        }
        if (message.excludeDeclines !== undefined && message.excludeDeclines !== false) {
            obj.excludeDeclines = message.excludeDeclines;
        }
        if (message.excludeActivityIds?.length) {
            obj.excludeActivityIds = message.excludeActivityIds;
        }
        if (message.timeOnOrBeforeMs !== undefined && message.timeOnOrBeforeMs !== '0') {
            obj.timeOnOrBeforeMs = message.timeOnOrBeforeMs;
        }
        if (message.timeAfterMs !== undefined && message.timeAfterMs !== '0') {
            obj.timeAfterMs = message.timeAfterMs;
        }
        if (message.isSettled !== undefined && message.isSettled !== false) {
            obj.isSettled = message.isSettled;
        }
        return obj;
    },
    create(base) {
        return exports.ActivityFilter.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityFilter();
        message.merchantId = object.merchantId ?? '';
        message.additionalMerchantIds = object.additionalMerchantIds?.map((e) => e) || [];
        message.includeAllSpending = object.includeAllSpending ?? false;
        message.isBnplEligible = object.isBnplEligible ?? false;
        message.isBlocked = object.isBlocked ?? false;
        message.isInternational = object.isInternational ?? false;
        message.excludeDeclines = object.excludeDeclines ?? false;
        message.excludeActivityIds = object.excludeActivityIds?.map((e) => e) || [];
        message.timeOnOrBeforeMs = object.timeOnOrBeforeMs ?? '0';
        message.timeAfterMs = object.timeAfterMs ?? '0';
        message.isSettled = object.isSettled ?? false;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=activity-query.js.map